//======================Centralized API Headers============================================
import axios from "axios";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

axios.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('authToken');
    console.log("=tokentokentoken==>>>",token);

    if (token) {
      config.headers["Authorization"] = token;
    }
      
    return config;
  },
  (error) => {
    return Promise.reject(error); // Handle any errors
  }

);

axios.interceptors.response.use(
  (response) => {
    console.log("===>>>",response.data);
    if (response.data === 'UNAUTHORIZED') {
      // window.location.href = '/';
        toast.warn("Session expired !! Please login again");
    }
    
    return response;  // Return the response if no error
  });

//=========================================================================================
// ================BASE API===================
 export const BaseIp = "https://server1.purnaacademic.in:8443/RockLedger/"    //===========Online URL
// export const BaseIp = "http://88.222.215.196:8080/RockLedger/"    //===========Online URL  //===2
// export const BaseIp = "http://192.168.29.102:8083/"    //===========Local URL  DAUD SIR
//export const BaseIp = "http://192.168.29.112:8082/"    //===========Local URL  CHAITANYA
// export const BaseIp = "http://192.168.29.189:8082/"    //===========Local URL  SHREYAS

//================REPORT BASE API===================
export const getReportDataApi= "https://server1.purnaacademic.in:8443/" // get Report Data Api  (online)
// export const getReportDataApi= "http://88.222.215.196:8080/" // get Report Data Api  (online)  //==2
//export const getReportDataApi= "http://192.168.29.102:8083/" // get Report Data Api  (Local URL  DAUD SIR)
//export const getReportDataApi= "http://192.168.29.112:8082/" // get Report Data Api  (Local URL  CHAITANYA)
// export const getReportDataApi= "http://192.168.29.189:8082/" // get Report Data Api  (Local URL  SHREYAS)